import React from 'react';
import HoursList from './HoursList';
import propDefs from '../proptypes';

const getSelectedDepts = ({ allHoursDepts, allHoursLabelIds }) => {
	const deptIds = allHoursDepts.split(',').map(dept => dept.trim());
	const labelIds = allHoursLabelIds.split(',').map(labelId => labelId.trim());

	const departments = [];
	deptIds.forEach((deptId, index) => {
		departments.push({
			deptId,
			deptLabel: labelIds[index] || 'DEPARTMENT_HOURS'
		});
	});
	return departments;
};

const Hours = ({ hours: hoursManifest, prefs, department, isModal }) => {
	if (!hoursManifest) {
		return null;
	}

	const hours = [];
	if (department) {
		// If a single department's hours were requested...
		hours.push({
			deptId: department,
			deptLabel: undefined,
			deptHours: hoursManifest[department]
		});
	} else {
		// Otherwise, get hours for all configured departments...
		const depts = getSelectedDepts(prefs);
		depts.forEach(dept => {
			if (hoursManifest[dept.deptId]) {
				hours.push({
					...dept,
					deptHours: hoursManifest[dept.deptId]
				});
			}
		});
	}

	const hoursList = hours.map(dept => (
		<HoursList
			key={dept.deptId}
			heading={dept.deptLabel}
			hours={dept.deptHours}
			isModal={isModal}
		/>
	));

	return <div>{hoursList}</div>;
};

Hours.defaultProps = {
	hours: propDefs.defaults.hours,
	department: undefined,
	isModal: propDefs.defaults.isModal
};

Hours.propTypes = {
	hours: propDefs.settings.hours,
	prefs: propDefs.settings.prefs.isRequired,
	department: propDefs.settings.department,
	isModal: propDefs.settings.isModal
};

export default Hours;



// WEBPACK FOOTER //
// ./src/components/Hours.jsx